import { useEffect } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import { getProfile } from 'store/profile/profile.action';

const selection = createSelector(
    [(state) => state.profileReducer, (state) => state.user],
    (profile, user) => ({ ...profile, ...user }),
);

export default function useGetProfile(
    { shouldFetch, ignoreRefetch } = {
        shouldFetch: true,
        ignoreRefetch: false,
    },
) {
    const dispatch = useDispatch();
    const {
        data,
        dataError,
        dataIsLoading,
        isUpdated,
        isAvatarUpdated,
        onboarded: isOnBoarded,
    } = useSelector(selection);

    useEffect(() => {
        if (dataIsLoading || !shouldFetch || (ignoreRefetch && data)) {
            return;
        }

        dispatch(getProfile());
    }, [isUpdated, isAvatarUpdated]);

    const fetch = () => dispatch(getProfile());

    return {
        data,
        error: dataError,
        isLoading: dataIsLoading,
        fetch,
    };
}
